<ng-container *ngIf="viewModel$ | async as viewModel">
  <div class="document-container">
    <div class="details" (click)="store.dispatch(actions.documentClicked({ artifactId: viewModel.estimate.id }))">
      <i class="pi pi-file"></i>
      <div>
        <div class="document-name">
          <span>{{ viewModel.estimate.name }}</span>
          <p-tag
            *ngFor="let tag of viewModel.tags"
            rounded="true"
            [style]="{
              backgroundColor: tag.backgroundColor,
              color: tag.color
            }"
            [value]="tag.text"
            styleClass="p-ml-2"
            ></p-tag>
        </div>
        <div>Created {{ viewModel.estimate.createdAt * 1000 | date : 'mediumDate' }} | {{ viewModel.estimate.fileSize | fileSize }} | {{ viewModel.estimate.public ? 'Public' : 'Private' }}</div>
      </div>
    </div>
    <div class="buttons">
      <p-button
        *ngIf="viewModel.sendDocumentButtonVisible"
        (onClick)="store.dispatch(actions.sendDocumentButtonClicked({ artifactId: viewModel.estimate.id }))"
        [icon]="viewModel.sendDocumentButtonIcon"
        [label]="viewModel.sendDocumentButtonLabel"
        [disabled]="viewModel.sendDocumentButtonDisabled"
        styleClass="p-mr-2"
        ></p-button>
      <p-button
        icon="pi pi-ellipsis-v"
        class="menu-btn"
        text="true"
        (click)="store.dispatch(actions.openDocumentActionsButtonClicked({ artifactId: viewModel.estimate.id }));menu.toggle($event)"
        ></p-button>
      <p-menu
        #menu
        [popup]="true"
        appendTo="body"
        [model]="viewModel.actionsMenu"
        ></p-menu>
    </div>
  </div>
</ng-container>
